import { styled } from "@mui/material";
import { scrollbarStyle } from "styles/global-styles";

export const Code = styled('div')(({ theme }) => ({
  whiteSpace: "pre",
  fontFamily: "Noto Sans Mono, monospace",
  padding: theme.spacing(4),
  paddingTop: theme.spacing(2),
  overflow: "auto",
  fontSize: 11,
  flexGrow: 1,
  ...scrollbarStyle
}))
